import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import Ajax from "./AJAX.jsx";


class Login extends React.Component {
     constructor(props)
   {
      super(props);
     
      this.state = new Object();
     
      this.state.email = "";
      this.state.password = "";
      this.state.errors = [];
    
      this.updateEmail = function(e){
         this.setState({email:e.target.value})
         }.bind(this);

           this.updatePassword = function(e) {
         this.setState({password:e.target.value})
      }.bind(this);


      this.tryPerformLogin = function()
      {
         var params = new Object();
         params['email'] = this.state.email;
         params['password'] = this.state.password;
         params['outputJS'] = true;
         function onComplete(responseObj)
         {

            if(!responseObj.success)
            {
               this.setState({errors:responseObj.error});
            }
            else
            {
               const onGetUserInfo = (resp) =>
               {
                  if(resp.user.role_name == "user")
                  {
                     this.props.appCallbacks.showMsg("Logged off automatically", "Ordinary users cannot login to admin panel.\nOnly leaders and master can.");
                     this.props.appCallbacks.performAjaxRequest("logout", "GET", null, null);
                  }
               }
               this.props.appCallbacks.performAjaxRequest("currentUser", "GET", null, onGetUserInfo);
               this.props.appCallbacks.changePageCallback('admin');
            }
            console.log("Got respone: ", responseObj);
         }
         //console.log("Logging in");
         this.props.appCallbacks.performAjaxRequest("login", "POST", params, onComplete.bind(this));
      }.bind(this);
   }

   componentDidMount()
   {
   }


   render() {
      return (
         <div>
            <h1 style={{display:'block'}}> Login</h1>

            Username: <input type="text" name="email" value={this.state.email}
            onChange={this.updateEmail}/>
            <br/><br/>
            Password: <input type="password" name="password" value={this.state.password}
            onChange={this.updatePassword}/>
            
            <br/>
            {this.state.errors.map((err, i) =>
            <span key = {i} className="error">{err}   <br/></span>)}
            
            <button onClick = {this.tryPerformLogin}>Log in</button>
         </div>
      );
   }
}

export default Login;


// WEBPACK FOOTER //
// ./js/Login.jsx